// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import FullScreenButton from './data'

export default function FullScreenButtonFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/FullScreenButton">
      <FullScreenButton {...props}>
        {children}
      </FullScreenButton>
    </Flow>
  )
}
